module.exports = __webpack_public_path__ + "img/home_success.1903196.f1663349.svg";